import {ThemeProvider} from "../../Shared/Theme/ThemeContext";
import {useEffect, useState} from "react";
import {SafetyData} from "../../Shared/Model/SafetyData";
import Network from "../../Shared/Util/Network";
import LoadingIndicator from "../../Shared/Components/LoadingIndicator";
import LoadError from "../../Shared/Components/LoadError";
import SafetyContent from "./SafetyContent";
import {BaseGameProps} from "../../Shared/Model/GameProps";

export default function SafetyLoader(props : BaseGameProps) {
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [data, setData] = useState<SafetyData>()

    useEffect(() => {
        Network.loadSafety(safety => {
            setIsLoading(false)
            setData(safety)
        })
    }, [])

    if (isLoading) {
        return <LoadingIndicator />
    } else if (data) {
        return <ThemeProvider value={props.theme}>
            <SafetyContent data={data} title={props.title} subtitle={props.subtitle} />
        </ThemeProvider>
    } else {
        return <LoadError />
    }
}
